(() => {
  const el = () => document.getElementById('wishlist-tooltip');
  const anchor = () =>
    document.querySelector('.wishlist__badge_header') || document.querySelector('a[href="/a/wishlist"]');

  let hideTimer = null;
  let ignoreCloseUntil = 0;

  const hide = () => {
    const tip = el();
    if (!tip) return;
    tip.classList.remove('is-visible');
    tip.setAttribute('hidden', '');
    clearTimeout(hideTimer);
  };

  const place = (tip) => {
    const heart = anchor();
    if (!heart) return;
    const r = heart.getBoundingClientRect();
    tip.style.cssText = `position:fixed;top:${Math.round(r.bottom + 12)}px;right:${Math.max(8, Math.round(window.innerWidth - r.right))}px;left:auto;z-index:9999`;
  };

  const revealHeader = () => {
    const header = document.querySelector('#header-component');
    if (!header?.getAttribute('sticky')) return;
    if (header.getAttribute('data-sticky-state') !== 'idle' && !header.hasAttribute('data-animating')) return;
    header.removeAttribute('data-animating');
    header.dataset.stickyState = 'active';
    header.dataset.scrollDirection = 'up';
  };

  const show = () => {
    const tip = el();
    if (!tip) return;

    ignoreCloseUntil = Date.now() + 700;
    revealHeader();

    setTimeout(() => {
      tip.removeAttribute('hidden');
      tip.classList.add('is-visible');
      place(tip);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 6000);
    }, 220);
  };

  window.__wishlistTooltipShow = show;
  [
    'SWCallbackExpressWishlistProductItemAdded',
    'SWCallbackExpressWishlistCollectionItemAdded',
    'SWCallbackCustomerWishlistProductItemAdded',
    'SWCallbackCustomerWishlistCollectionItemAdded',
  ].forEach((name) => {
    window[name] = show;
  });

  if (window.__wishlistTooltipQueue?.length) {
    window.__wishlistTooltipQueue = [];
    show();
  }

  document.addEventListener('click', (event) => {
    if (Date.now() < ignoreCloseUntil) return;
    const tip = el();
    if (!tip?.classList.contains('is-visible')) return;
    if (event.target.closest?.('#wishlist-tooltip, .wishlist-header-wrap')) return;
    hide();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hide();
  });
})();
